<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.task')"
    resource="tasks"
    :actionColumnProps="{ width: 120 }"
  />
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/tasks.js';
import { columnsExtend as taskAssignmentColumnsExtend } from '../admin_grapes/task_assignments.js';
import { columnsExtend as followRecordColumnsExtend } from '../admin_grapes/follow_records.js';
import { TAG_TYPE } from '@/constants';
import Utils from '../components/utils.vue';
import _ from 'lodash';
import { displayText } from '@/custom_models_extend';
import DialogContent from '@/components/dialog-content.vue';
import CustomerDialog from '@/components/customer-dialog.vue';

@Component
export default class Tasks extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      this.roleKind !== 'salesman' && this.roleKind !== 'customer_service' && {
        key: 'assignees_id_eq',
        label: '执行人',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              return (await this.$request.get('users/read_options', { per_page: 100, role_kind_in: ['salesman', 'customer_service'] })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('users/read_options', { keyword, role_kind_in: ['salesman', 'customer_service'] })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      (this.roleKind === 'salesman' || this.roleKind === 'customer_service') && {
        key: 'creator_id_eq',
        renderCell: {
          props: {
            clearable: true,
            xRemotePreload: async () => {
              return (await this.$request.get('users/read_options', { per_page: 100, role_kind_in: ['business_executive', 'channel_business_executive'] })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('users/read_options', { keyword, role_kind_in: ['business_executive', 'channel_business_executive'] })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      'title_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      type === 'show' && 'content',
      'display_filters',
      (this.roleKind === 'salesman' || this.roleKind === 'customer_service') && ([
        'creator',
        ...taskAssignmentColumnsExtend([
          {
            prop: 'task_assignments.0.state',
            label: this.$t('taskAssignment.state'),
            renderCell: (h, { props: { value } }) => {
              return <el-tag type={TAG_TYPE[value]}>{this.$t(`taskAssignment.states.${value}`)}</el-tag>;
            }
          },
          type === 'show' && {
            prop: 'task_assignments.0.reply',
            label: this.$t('taskAssignment.reply'),
            renderCell: 'app-multiple-row-text'
          },
          {
            prop: 'task_assignments.0.follow_ratio',
            label: this.$t('taskAssignment.followRatio'),
            renderCell: (h, { props: { value, scope: { row } } }) => {
              return <span>{(value * 100).toFixed(2)}%({_.get(row, 'task_assignments.0.followed_customers_count', '-')}/{_.get(row, 'task_assignments.0.customers_count', '-')})</span>
            }
          },
          type === 'show' && {
            prop: 'task_assignments.0.followed_customers',
            label: '跟进客户详情',
            renderCell: (h, { props: { scope: { row } } }) => {
              const mapItem = (item) => {
                return {
                  id: item.id,
                  name: displayText(item),
                  to: {
                    name: 'customers.show',
                    params: { id: item.id },
                    query: { task_assignment_id: _.get(row, 'task_assignments.0.id') }
                  }
                }
              }
              return (
                <CustomerDialog
                  title="跟进客户详情"
                  groups={[
                    {
                      title: '未跟进客户',
                      type: 'danger',
                      list: _.get(row, 'task_assignments.0.unfollowed_customers', []).map(mapItem)
                    },
                    {
                      title: '已跟进客户',
                      type: 'success',
                      list: _.get(row, 'task_assignments.0.followed_customers', []).map(mapItem)
                    }
                  ]}
                />
              );
            }
          },
        ].filter(Boolean))
      ]),
      this.roleKind !== 'salesman' && this.roleKind !== 'customer_service' && {
        key: 'task_assignments',
        type: 'expand',
        width: 120,
        renderCell: (h, { props: { value } }) => {
          let columns = ['assignee', 'state', {
            key: 'follow_ratio',
            width: 100,
            renderCell: (h, { props: { value, scope: { row } } }) => {
              return <span>{(value * 100).toFixed(2)}%({_.get(row, 'followed_customers_count', '-')}/{_.get(row, 'customers_count', '-')})</span>
            }
          }]
          if (type === 'show') {
            columns.push({
              minWidth: 200,
              key: 'reply',
              renderCell: 'app-multiple-row-text'
            })
            columns.push({
              key: 'follow_records',
              width: 120,
              renderCell: (h, { props: { value } }) => {
                return (
                  <DialogContent title="跟进记录">
                    <bean-table height="60vh" value={value} columns={followRecordColumnsExtend([
                      'customer',
                      'followed_at',
                      {
                        key: 'content',
                        minWidth: 160,
                        renderCell: 'app-multiple-row-text'
                      },
                      { key: 'media', width: 120, className: 'small-media-section' }
                    ])} />
                  </DialogContent>
                )
              },
            })
            columns.push({
              prop: 'followed_customers',
              label: '跟进客户详情',
              width: 200,
              renderCell: (h, { props: { scope: { row } } }) => {
                const itemRouteQuery = _.get(row, 'assignee_id') === this.currentUser.id ? { task_assignment_id: row.id } : {};
                const mapItem = (item) => {
                  return {
                    id: item.id,
                    name: displayText(item),
                    to: {
                      name: 'customers.show',
                      params: { id: item.id },
                      query: itemRouteQuery
                    }
                  }
                };
                return (
                  <CustomerDialog
                    title="跟进客户详情"
                    groups={[
                      {
                        title: '未跟进客户',
                        type: 'danger',
                        list: row.unfollowed_customers.map(mapItem)
                      },
                      {
                        title: '已跟进客户',
                        type: 'success',
                        list: row.followed_customers.map(mapItem)
                      }
                    ]}
                  />
                );
              }
            })
          }
          return <bean-table size="small" height={null} value={value} columns={taskAssignmentColumnsExtend(columns)} actions={this.taskAssignmentActions} />
        },
      },
      this.roleKind !== 'salesman' && this.roleKind !== 'customer_service' && {
        key: 'follow_ratio',
        width: 100,
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <span>{(value * 100).toFixed(2)}%({_.get(row, 'followed_customers_count', '-')}/{_.get(row, 'customers_count', '-')})</span>
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(_.flatten(array))
  }

  taskAssignmentActions({ row }) {
    return [
      this.currentUser.id === row.assignee_id && row.state === 'pending' && {
        component: 'confirmButton',
        props: {
          label: '处理',
          type: 'primary',
          can: 'task_assignments.process'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/task_assignments/${_.get(row, 'id')}/process`));
            this.$message.success(this.$t('operateSuccess'));
            window.location.reload();
          }
        }
      },
      this.currentUser.id === row.assignee_id && row.state === 'processing' && {
        component: 'dialogFormButton',
        props: {
          label: '完成',
          type: 'primary',
          value: {},
          can: 'task_assignments.complete',
          columns: [{
            prop: 'reply',
            label: '回复',
            renderCell: {
              component: 'textarea',
              required: true,
            }
          }],
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/task_assignments/${row.id}/complete`, value));
            this.$message.success(this.$t('operateSuccess'));
            window.location.reload();
          }
        }
      }
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'title',
      'content',
      {
        key: 'assignee_ids',
        renderCell: {
          props: {
            xRemotePreload: async () => {
              return (await this.$request.get('users/read_options', { per_page: 100, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('users/read_options', { keyword, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
        }
      },
      {
        key: 'filters',
        renderCell: {
          component: 'staticNestForm',
          required: false,
          props: {
            columns: [
              {
                prop: 'customer.customer_source_id_in',
                label: '客户来源',
                renderCell: {
                  component: 'select',
                  props: {
                    clearable: true,
                    multiple: true,
                    xRemotePreload: async () => {
                      return (await this.$request.get('customer_sources/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
                    },
                    xRemoteSearch: async (keyword) => {
                      return (await this.$request.get('customer_sources/read_options', { keyword })).data.map(item => ({ value: item.id, label: item.name }));
                    }
                  },
                }
              },
              {
                prop: 'customer.customer_level_id_in',
                label: '客户级别',
                renderCell: {
                  component: 'select',
                  props: {
                    clearable: true,
                    multiple: true,
                    xRemotePreload: async () => {
                      return (await this.$request.get('customer_levels/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
                    },
                    xRemoteSearch: async (keyword) => {
                      return (await this.$request.get('customer_levels/read_options', { keyword })).data.map(item => ({ value: item.id, label: item.name }));
                    }
                  },
                }
              },
              {
                prop: 'customer.customer_business_models_id_in',
                label: '客户业务模式',
                renderCell: {
                  component: 'select',
                  props: {
                    clearable: true,
                    multiple: true,
                    xRemotePreload: async () => {
                      return (await this.$request.get('customer_business_models/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
                    },
                    xRemoteSearch: async (keyword) => {
                      return (await this.$request.get('customer_business_models/read_options', { keyword })).data.map(item => ({ value: item.id, label: item.name }));
                    }
                  }
                }
              },
              {
                prop: 'customer.customer_tags_id_in',
                label: '客户标签',
                renderCell: {
                  component: 'select',
                  props: {
                    clearable: true,
                    multiple: true,
                    xRemotePreload: async () => {
                      return (await this.$request.get('customer_tags/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
                    },
                    xRemoteSearch: async (keyword) => {
                      return (await this.$request.get('customer_tags/read_options', { keyword })).data.map(item => ({ value: item.id, label: item.name }));
                    }
                  }
                }
              }
            ]
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'tasks.edit', params: { id: row.id } }
        }
      },
      (this.roleKind === 'salesman' || this.roleKind === 'customer_service') && _.get(row, 'task_assignments.0.state') === 'pending' && {
        component: 'confirmButton',
        props: {
          label: '处理',
          type: 'primary',
          can: 'task_assignments.process'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/task_assignments/${_.get(row, 'task_assignments.0.id')}/process`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      (this.roleKind === 'salesman' || this.roleKind === 'customer_service') && _.get(row, 'task_assignments.0.state') === 'processing' && {
        component: 'dialogFormButton',
        props: {
          label: '完成',
          type: 'primary',
          value: {},
          can: 'task_assignments.complete',
          columns: [{
            prop: 'reply',
            label: '回复',
            renderCell: {
              component: 'textarea',
              required: true,
            }
          }],
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/task_assignments/${_.get(row, 'task_assignments.0.id')}/complete`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'tasks.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/tasks',
    name: 'tasks.index',
    component: Tasks,
    props: {
      type: 'index',
    }
  },
  {
    path: '/tasks/new',
    name: 'tasks.new',
    component: Tasks,
    props: {
      type: 'new',
    }
  },
  {
    path: '/tasks/:id',
    name: 'tasks.show',
    component: Tasks,
    props: {
      type: 'show',
    }
  },
  {
    path: '/tasks/:id/edit',
    name: 'tasks.edit',
    component: Tasks,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style lang="scss">
.task-show-dialog-body {
  .group {
    margin-bottom: 20px;
  }

  .title {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>
